






























































































































import {Vue, Watch, Component, PropSync} from 'vue-property-decorator';
import proxySettingsForm from "@/pages/Pages/Push/proxySettingsForm.vue";
import {SelectWings} from "wings-ui-components";
import {FcmType} from "@/store/push/application/types";
import {isEmpty} from "lodash";

@Component({
  components: {SelectWings, proxySettingsForm}
})
export default class FCMComponent extends Vue {
  @PropSync('fcmOptions') fcm!: FcmType;
  @PropSync('filesOptions') files!: { file: File, type: string }[];

  private serverTypeList: string[] = ['PRODUCTION', 'DEVELOPMENT']

  get isFCMProxy(): boolean {
    return !isEmpty(this.fcm.proxy_settings);
  }

  set isFCMProxy(value: boolean) {
    if (value) {
      this.$set(this.fcm, 'proxy_settings', { host: null });
    } else {
      this.$delete(this.fcm, 'proxy_settings');
    }
  }

  onFilePicked(file: File, type?: string | null) {
    if (!type) return;
    this.files?.push({file: file, type: type});
  }
}
